import React from 'react'

export const BtnSearch = ({ value, onChange, placeholder, style, className }) => {
  const inputClass = className
    ? `${className} inp-search-tools`
    : "inp-search-tools";
  return (
    <input
      placeholder={placeholder}
      type="text"
      className={inputClass}
      value={value}
      onChange={onChange}
      style={style}
    />
  );
};
